export default {"src":"/_next/static/media/file-paket-soal.e28cf944.svg","height":14,"width":16};